import React, { Component } from "react";
import { connect } from "react-redux";
import Accordion from "@material-ui/core/Accordion";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";

import _ from "lodash";
import * as qs from "query-string";

import PageView from "./PageView";
import {
  discardRestoreAnnotation,
  readAnnotationMessage,
} from "@safecv/actions/postActions";
import CriteriaView from "./CriteriaView";

import "./Annotations.css";
import "./AccordionView.css";

const styles = {
  expanded: {
    margin: "2px 0 !important",
  },
  expandedIcon: {
    color: "#4183C5",
  },
};

class AccordionView extends Component {
  groupBy =
    this.props.viewType === "annotated" ? this.props.groupBy : "focusPage";

  state = {
    expanded: "panel-" + this.props.groupByValue,
    page: this.props.focusPage,
  };

  handleChange = (panel) => (event, isExpanded) => {
    this.setState({
      expanded: isExpanded ? panel : false,
    });
  };

  componentWillReceiveProps(newProps) {
    let groupBy = this.groupBy;
    if (newProps.focusPage !== this.state.page) {
      this.setState({
        page: newProps.focusPage,
        expanded: "panel-" + newProps.groupByValue,
      });
    }

    try {
      let urlSearch = qs.parse(window.location.search);
      _.forEach(newProps.groupedItems, (groupSubItems, groupItem) => {
        for (let i = 0; i < groupSubItems.length; i++) {
          //Fallback
          if (!groupSubItems[i][groupBy]) {
            groupBy = "pageNo";
          }
          if (
            groupSubItems[i][groupBy] === parseInt(urlSearch[groupBy]) &&
            groupSubItems[i].id === parseInt(urlSearch.annotationId)
          ) {
            this.setState({
              expanded: "panel-" + groupSubItems[i][groupBy],
            });
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { classes, groupBy } = this.props;
    let groupedItems = [];
    let props = this.props,
      expanded = this.state.expanded,
      index = 0;
    //Junk methods
    //let isFirstItem = true;
    _.forEach(this.props.groupedItems, (groupSubItems, groupItem) => {
      index++;
      //Fallback
      let expand = groupSubItems[0][groupBy] || groupSubItems[0].pageNo,
          description = groupSubItems[0]["codebookDescription"],
          sheetnumber = groupSubItems[0].sheetNumber;

      groupSubItems = groupSubItems.map((annotation) => {
        return props.viewType === "symbols" ? (
          <PageView
            annotation={annotation}
            key={annotation.id}
            setSelectedAnnotation={props.setSelectedAnnotation}
            changeFocus={props.changeFocus}
            selectedAnnotation={props.selectedAnnotation}
            annotationRefs={props.annotationRefs}
          />
        ) : (
          <CriteriaView
            {...props}
            key={annotation.id}
            annotation={annotation}
            annotationId={annotation.id}
          />
        );
      });

      let groupMainItem = (
        <Accordion
          className={classes.expanded}
          key={index}
          expanded={expanded === "panel-" + expand}
          onChange={this.handleChange("panel-" + expand)}
        >
          <AccordionSummary
            className="annotationbar sidebar-annotation"
            expandIcon={<ExpandMoreIcon className={classes.expandedIcon} />}
          >
            <Typography>
              <div 
                className="text-fullwidth-wrap"
                title={`${groupItem} (${groupSubItems.length}) ${groupBy === "ruleIndex" && description ? `${description}` :
                    groupBy === "pageNo" && sheetnumber ? `Sheet ${sheetnumber}` : ""}`
                }
                >
                <span className="sidebar-annotation-text"
                >
                  {groupItem} ({groupSubItems.length})
                </span>
                {groupBy === "ruleIndex" && description ? (
                  <span className="code-description">
                    {description}
                  </span>
                ) :
                groupBy === "pageNo" && sheetnumber ? (
                  <span className="code-description">
                    Sheet {sheetnumber}
                  </span>
                ) :
                null}
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="annotation-text-wrap" id="pdfWrapper">
            {groupSubItems}
          </AccordionDetails>
        </Accordion>
      );
      groupedItems.push(groupMainItem);
    });

    let groupedAccordion = <> {groupedItems} </>;
    return groupedAccordion;
  }
}

const mapStatetoProps = (state) => ({
  annotationPayload: state.verification.annotationPayload,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    discardRestoreAnnotation: (
      jobId,
      annotationId,
      type,
      isDiscarded,
      reasonForDiscard
    ) => {
      dispatch(
        discardRestoreAnnotation(
          jobId,
          annotationId,
          type,
          isDiscarded,
          reasonForDiscard
        )
      );
    },
    readAnnotationMessage: (jobId, annotationId, type, value) => {
      dispatch(readAnnotationMessage(jobId, annotationId, type, value));
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(withStyles(styles)(AccordionView));
